/* v6-quiz-interstitial.js
   Shows the homepage quiz modal once per visitor (30-day cookies).
   Triggers 200ms after DOMContentLoaded; 300ms fade.
   Closes on: primary click (CTA navigates), skip click, X click, ESC key, backdrop click.
   Sets cookies `lovingsex_quiz_seen=1` and `ls_popup_dismissed=1` on any close path.
*/

(function () {
  'use strict';

  var COOKIE_NAME = 'lovingsex_quiz_seen';
  var DISMISSED_COOKIE_NAME = 'ls_popup_dismissed';
  var SHOWN_STORAGE_KEY = 'ls_popup_shown';
  var COOKIE_TTL_DAYS = 30;
  var popupState = window.__lsPopupFrequency || (window.__lsPopupFrequency = {
    shown: false,
    dismissed: false
  });

  function readCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[$()*+./?[\\\]^{|}]/g, '\\$&') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function writeCookie(name, value, days) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    } catch (e) {}
  }

  function hasPopupShown() {
    if (popupState.shown) return true;
    try {
      if (sessionStorage.getItem(SHOWN_STORAGE_KEY)) {
        popupState.shown = true;
        return true;
      }
    } catch (e) {}
    return false;
  }

  function markPopupShown() {
    popupState.shown = true;
    try { sessionStorage.setItem(SHOWN_STORAGE_KEY, '1'); } catch (e) {}
  }

  function hasPopupDismissed() {
    if (popupState.dismissed) return true;
    if (readCookie(DISMISSED_COOKIE_NAME)) {
      popupState.dismissed = true;
      return true;
    }
    return false;
  }

  function dismissPopups() {
    popupState.dismissed = true;
    writeCookie(COOKIE_NAME, '1', COOKIE_TTL_DAYS);
    writeCookie(DISMISSED_COOKIE_NAME, '1', COOKIE_TTL_DAYS);
  }

  function close(modal) {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    dismissPopups();
    document.body.style.overflow = '';
  }

  function open(modal) {
    if (!modal || hasPopupDismissed() || hasPopupShown()) return;
    markPopupShown();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function init() {
    // Only fire on the homepage
    var path = window.location.pathname.replace(/\/$/, '');
    if (path !== '' && path !== '/') return;

    if (readCookie(COOKIE_NAME) || hasPopupDismissed() || hasPopupShown()) return;

    var modal = document.querySelector('[data-v6-quizmodal]');
    if (!modal) return;

    // Show after a brief paint-settle delay
    setTimeout(function () { open(modal); }, 200);

    // X button + Skip button + any [data-v6-quizmodal-close]
    modal.querySelectorAll('[data-v6-quizmodal-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); close(modal); });
    });

    // Take-the-quiz: set both dismissal cookies, then let the link navigate
    var takeLink = modal.querySelector('[data-v6-quizmodal-take]');
    if (takeLink) {
      takeLink.addEventListener('click', dismissPopups);
    }

    // Backdrop click (clicked the .v6-quizmodal but not the inner card)
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close(modal);
    });

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close(modal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
